import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
interface DialogData {
    message: string;
    title: string;
}
@Component({
    selector: 'clever-comment',
    templateUrl: './comment.component.html',
    styleUrls: ['./comment.component.scss'],
    standalone: false
})
export class CommentComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<CommentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) { }

    ngOnInit(): void {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onSaveClick(): void {
        this.data.message = this.data.message.slice(0, 10000);
        this.dialogRef.close(this.data);
    }
}
